import React, { useContext } from "react";
import { WplywContext } from "../../../../../../../context/wplywContext";
import { Select, Input, Button, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import LineSpacer from "../../../../../../../components/LineSpacer";
import CalculatorInput from "../../../../../../../components/CalculatorInput";
import ReckoningsDeduction from "./ReckoningsDeduction";
import { useState } from "react";
import { useAuth } from "../../../../../../../context/AuthContext";
import FixedNumberInput from "../../../../../../../components/FixedNumberInput";
import Label from "../../../../../../../components/Label";
import formatPrice from "../../../../../../../components/formatPrice";
import CommentWithFragments from "../../../../../../../components/CommentWithFragments";
import { message } from "antd";

const Reckonings = ({ selectedPerson, reckoning, index }) => {
	const [open, setOpen] = useState(true);
	const { wplyw, setWplyw } = useContext(WplywContext);
	const [globalpercent, setGlobalpercent] = useState(0);
	const [reckglobalpercent, setReckGlobalpercent] = useState(
		(reckoning.msr_reckonings_deduction_from_income /
			reckoning.msr_reckonings_part_amount) *
			100 >
			100
			? 100
			: (reckoning.msr_reckonings_deduction_from_income /
					reckoning.msr_reckonings_part_amount) *
					100,
	);
	const { user } = useAuth();
	const MAX_PERCENTAGE = 100; // Define your maximum value here
	const labelStyle = {
		color: "black",
		fontWeight: "500",
		fontSize: "16px",
		marginBottom: "8px",
	};
	const valueStyle = {
		color: "black",
		fontWeight: "700",
		fontSize: "16px",
	};
	const bigStyle = {
		color: "black",
		fontWeight: "700",
		fontSize: "22px",
	};

	const isGeneratedTransferLocked =
		Boolean(selectedPerson?.msr_persons_transfers_generated_file) ||
		Boolean(selectedPerson?.msr_reserves_generated_file) ||
		Boolean(
			(selectedPerson?.msr_transfers || []).some(
				(t) => t?.msr_transfers_generated_file,
			),
		);
	const isDisabled = wplyw.mode === "preview" || isGeneratedTransferLocked;

	// Remove reckoning
	const removeReckoning = () => {
		if (reckoning.msr_deductions.length > 0) {
			// Show confirmation modal if there are deductions
			Modal.confirm({
				title: "Czy na pewno chcesz usunąć to rozliczenie?",
				content:
					"To rozliczenie zawiera odliczenia. Usunięcie spowoduje utratę wszystkich danych powiązanych z tym rozliczeniem.",
				okText: "Usuń",
				cancelText: "Anuluj",
				onOk: () => performRemoveReckoning(), // Call actual delete function if confirmed
			});
		} else {
			performRemoveReckoning(); // Directly delete if no deductions
		}
	};

	// Perform the actual deletion of the reckoning
	const performRemoveReckoning = () => {
		setWplyw((prevData) => {
			const updatedPersons =
				prevData.wplyw_data.data.msr_wplywy.msr_persons.map(
					(person) => {
						if (
							person.msr_persons_id ===
							selectedPerson.msr_persons_id
						) {
							return {
								...person,
								msr_reckonings: person.msr_reckonings.filter(
									(r) =>
										r.msr_reckonings_id !==
										reckoning.msr_reckonings_id,
								),
							};
						}
						return person;
					},
				);

			// Add log entry for removing the reckoning
			const changes = [...(prevData.changes || [])];
			changes.push({
				etap: "Rozliczenie",
				field: "msr_reckonings",
				label: "Usunięto rozliczenie",
				action: "remove",
				oldValue: `Usunięto rozliczenie o ID ${reckoning.msr_reckonings_own_id}`,
				newValue: `Usunięto rozliczenie o ID ${reckoning.msr_reckonings_own_id}`,
				datetime: Math.floor(new Date().getTime() / 1000),
				user: user.user.mlg_users_id,
				objectid: reckoning.msr_reckonings_own_id,
				wplywid: prevData.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
			});

			return {
				...prevData,
				wplyw_data: {
					...prevData.wplyw_data,
					data: {
						...prevData.wplyw_data.data,
						msr_wplywy: {
							...prevData.wplyw_data.data.msr_wplywy,
							msr_persons: updatedPersons,
						},
					},
				},
				changes, // Update the changes array
			};
		});
	};

	// Add a new deduction
	const addDeduction = () => {
		const defaultDeductionType =
			wplyw?.wplyw_data?.data?.default_values?.msr_deduction_types?.[0];
		if (!defaultDeductionType?.value) {
			message.error(
				"Brak skonfigurowanych typów odliczeń. Skontaktuj się z administratorem.",
			);
			return;
		}

		setGlobalpercent(defaultDeductionType.value);
		const newDeduction = {
			msr_deductions_id: "temp_" + Date.now(), // Use timestamp for unique ID
			msr_deductions_own_id: `${Math.floor(new Date().getTime() / 1000)}`,
			msr_deductions_title: "Nowe odliczenie",
			msr_deduction_types_id: defaultDeductionType.value,
			msr_reckonings_id: reckoning.msr_reckonings_id,
			msr_deductions_comment: "",
			msr_deductions_amount: 0,
			msr_loans_id: null,
			msr_loan_borrowers_id: null,
			userDetails: selectedPerson.userDetails,
		};

		setWplyw((prevData) => {
			const updatedPersons =
				prevData.wplyw_data.data.msr_wplywy.msr_persons.map(
					(person) => {
						if (
							person.msr_persons_id ===
							selectedPerson.msr_persons_id
						) {
							return {
								...person,
								msr_reckonings: person.msr_reckonings.map(
									(r) =>
										r.msr_reckonings_id ===
										reckoning.msr_reckonings_id
											? {
													...r,
													msr_deductions: [
														...(r.msr_deductions ||
															[]),
														newDeduction,
													],
												}
											: r,
								),
							};
						}
						return person;
					},
				);

			// Add new deduction creation to changes
			const changes = [...(prevData.changes || [])];
			changes.push({
				etap: "Odliczenia",
				field: "msr_deductions",
				label: "Nowe odliczenie",
				action: "add",
				oldValue: null,
				newValue: `Dodano nowe odliczenie o ID ${newDeduction.msr_deductions_own_id}`,
				datetime: Math.floor(new Date().getTime() / 1000),
				user: user.user.mlg_users_id,
				objectid: newDeduction.msr_deductions_own_id,
				wplywid: wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
				personid: selectedPerson.msr_persons_own_id,
			});

			return {
				...prevData,
				wplyw_data: {
					...prevData.wplyw_data,
					data: {
						...prevData.wplyw_data.data,
						msr_wplywy: {
							...prevData.wplyw_data.data.msr_wplywy,
							msr_persons: updatedPersons,
						},
					},
				},
				changes: changes,
			};
		});
	};

	const checkValues = (field, value) => {
		switch (field) {
			case "msr_reckonings_items_id":
				return wplyw.wplyw_data.data.default_values.msr_reckonings_items.find(
					(x) => x.value == value,
				).label;
			case "msr_reckonings_types_id":
				return wplyw.wplyw_data.data.default_values.msr_reckonings_types.find(
					(x) => x.value == value,
				).label;
			default:
				return value; // Return the value unchanged if no specific case is matched
		}
	};

	const updateReckoningField = (field, value, percent = null) => {
		const fieldLabels = {
			msr_reckonings_part_amount: "Podział kwoty wpływu",
			msr_reckonings_deduction_from_income: "Rozliczenie od wpływu",
			msr_reckonings_items_id: "Przedmiot kwoty wpływu",
			msr_reckonings_types_id: "Typ rozliczenia",
			msr_reckonings_document: "Numer dokumentu",
			msr_reckonings_comment: "Uwagi do rozliczenia",
		};
		setWplyw((prevData) => {
			const updatedPersons =
				prevData.wplyw_data.data.msr_wplywy.msr_persons.map(
					(person) => {
						if (
							person.msr_persons_id ===
							selectedPerson.msr_persons_id
						) {
							if (field === "msr_reckonings_items_id") {
								const selectedItem =
									wplyw.wplyw_data.data.default_values.msr_reckonings_items.find(
										(item) => item.value === value,
									);
								const defaultPercent =
									selectedPerson?.msr_persons_commission &&
									selectedItem?.msr_reckonings_items_access_to_default
										? selectedPerson?.msr_persons_commission
										: selectedItem?.msr_reckonings_items_default_percent ||
											0;
								return {
									...person,
									msr_reckonings: person.msr_reckonings.map(
										(r) =>
											r.msr_reckonings_id ===
											reckoning.msr_reckonings_id
												? {
														...r,
														[field]: value,
														msr_reckonings_deduction_from_income:
															(defaultPercent /
																100) *
															r.msr_reckonings_part_amount,
													}
												: r,
									),
								};
							} else if (field == "msr_reckonings_part_amount") {
								return {
									...person,
									msr_reckonings: person.msr_reckonings.map(
										(r) =>
											r.msr_reckonings_id ===
											reckoning.msr_reckonings_id
												? {
														...r,
														[field]: value,
														msr_reckonings_deduction_from_income:
															(parseFloat(
																reckglobalpercent,
															) /
																100) *
															parseFloat(value),
													}
												: r,
									),
								};
							} else {
								return {
									...person,
									msr_reckonings: person.msr_reckonings.map(
										(r) =>
											r.msr_reckonings_id ===
											reckoning.msr_reckonings_id
												? { ...r, [field]: value }
												: r,
									),
								};
							}
						}
						return person;
					},
				);

			const changes = [
				...(prevData.changes || []).filter(
					(change) =>
						!(
							change.field === field &&
							change.objectid === reckoning.msr_reckonings_own_id
						),
				),
			];
			changes.push({
				etap: "Rozliczenie",
				field: field,
				label: fieldLabels[field],
				action: "edit",
				oldValue: null,
				newValue: value,
				datetime: Math.floor(new Date().getTime() / 1000),
				user: user.user.mlg_users_id,
				objectid: reckoning.msr_reckonings_own_id,
				wplywid: wplyw.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
				personid: selectedPerson.msr_persons_own_id,
			});

			return {
				...prevData,
				wplyw_data: {
					...prevData.wplyw_data,
					data: {
						...prevData.wplyw_data.data,
						msr_wplywy: {
							...prevData.wplyw_data.data.msr_wplywy,
							msr_persons: updatedPersons,
						},
					},
				},
				changes,
			};
		});
	};

	// Handle percent change
	const handlePercentChange = (value) => {
		const percent = parseFloat(value);
		setGlobalpercent(value);
		if (!isNaN(percent) && percent >= 0) {
			if (percent > MAX_PERCENTAGE) {
				const newDeduction =
					(100 / 100) * reckoning.msr_reckonings_part_amount;
				updateReckoningField(
					"msr_reckonings_deduction_from_income",
					newDeduction,
				);
			} else {
				const newDeduction =
					(percent / 100) * reckoning.msr_reckonings_part_amount;
				updateReckoningField(
					"msr_reckonings_deduction_from_income",
					newDeduction,
				);
			}
		}
	};

	return (
		<div style={{ marginTop: "16px" }}>
			<div
				style={{
					padding: "20px",
					border: "1px solid #BD8136",
					borderRadius: "10px",
					background: "#F9F9F9",
					display: "grid",
					gap: "24px",
				}}
			>
				<div
					style={{
						display: "flex",
						gap: "20px",
						alignItems: "center",
					}}
				>
					<div
						style={{
							background: "black",
							color: "white",
							padding: "7px 15px",
							fontSize: "16px",
							width: "fit-content",
							borderRadius: "5px",
						}}
					>
						#{index + 1} Rozliczenie #
						{reckoning?.msr_reckonings_own_id}
					</div>
					<Button onClick={() => setOpen(!open)}>
						{open ? "Zwiń" : "Rozwiń"}
					</Button>
					<LineSpacer />
					{!isDisabled && (
						<Button
							danger
							onClick={removeReckoning}
						>
							Usuń rozliczenie
						</Button>
					)}
				</div>
				<div
					style={{
						display: open ? "grid" : "none",
						gridTemplateColumns:
							"repeat(auto-fit, minmax(150px, 1fr))",
						alignItems: "end",
						gap: "32px",
					}}
				>
					{/* Calculator for "Podział kwoty wpływu" */}
					<div>
						<Label required>Podział kwoty wpływu</Label>
						<FixedNumberInput
							mode={wplyw.mode}
							disabled={isDisabled}
							value={reckoning.msr_reckonings_part_amount}
							calculator={true}
							maxvalue={
								selectedPerson.msr_persons_amount -
								selectedPerson.msr_reckonings.reduce(
									(sum, reck) =>
										sum +
										(reck?.msr_reckonings_own_id !=
										reckoning.msr_reckonings_own_id
											? parseFloat(
													reck?.msr_reckonings_part_amount,
												)
											: 0),
									0,
								)
							}
							addonAfter="zł"
							onChange={(value) =>
								updateReckoningField(
									"msr_reckonings_part_amount",
									value,
								)
							}
							status={
								reckoning.msr_reckonings_part_amount &&
								reckoning.msr_reckonings_part_amount > 0
									? "default"
									: "error"
							}
						/>
					</div>

					{/* Select for "Przedmiot kwoty wpływu" */}
					<div>
						<Label required>Przedmiot kwoty wpływu</Label>
						<Select
							style={{ width: "100%" }}
							disabled={isDisabled}
							value={
								reckoning.msr_reckonings_items_id ||
								wplyw?.wplyw_data?.data?.default_values
									?.msr_reckonings_items[0].value
							}
							options={
								wplyw?.wplyw_data?.data?.default_values
									?.msr_reckonings_items || []
							}
							onChange={(value) =>
								updateReckoningField(
									"msr_reckonings_items_id",
									value,
								)
							}
						/>
					</div>

					{/* Procent Rozliczenia */}
					<div
						style={{
							gridColumn: "span 2",
							display: "grid",
							gridTemplateColumns: "1fr 1fr",
							gap: "16px",
							position: "relative",
							alignItems: "end",
						}}
					>
						<div
							style={{
								position: "absolute",
								border: "2px solid #BD8136",
								borderTop: "none",
								width: "calc(100% + 16px)",
								height: "20px",
								left: "-8px",
								bottom: "-8px",
							}}
						></div>
						<div>
							<Label required>Procent prowizji</Label>
							<FixedNumberInput
								mode={wplyw.mode}
								calculator={true}
								disabled={isDisabled}
								value={(
									(reckoning.msr_reckonings_deduction_from_income /
										reckoning.msr_reckonings_part_amount) *
									100
								).toFixed(2)}
								maxvalue={100}
								addonAfter="%"
								onChange={(value) => {
									setReckGlobalpercent(value);
									return handlePercentChange(value);
								}}
							/>
						</div>
						<div>
							<Label required>Prowizja od wypływu</Label>
							<FixedNumberInput
								mode={wplyw.mode}
								disabled={isDisabled}
								calculator={true}
								value={
									reckoning.msr_reckonings_deduction_from_income
								}
								maxvalue={reckoning.msr_reckonings_part_amount}
								addonAfter="zł"
								onChange={(value) => {
									// Ensure value is a string before calling .replace()
									let sanitizedValue = String(value).replace(
										",",
										".",
									);

									// If the input ends with a comma, append a zero
									if (
										sanitizedValue.includes(",") &&
										sanitizedValue.endsWith(",")
									) {
										sanitizedValue = `${sanitizedValue}0`;
									}

									const newValue =
										parseFloat(sanitizedValue).toFixed(2);
									if (!isNaN(newValue) && newValue >= 0) {
										if (
											newValue >
											reckoning.msr_reckonings_part_amount
										) {
											// Cap the value to the maximum allowed
											updateReckoningField(
												"msr_reckonings_deduction_from_income",
												reckoning.msr_reckonings_part_amount,
											);
										} else {
											updateReckoningField(
												"msr_reckonings_deduction_from_income",
												newValue,
											);
										}
									}
								}}
							/>
						</div>
					</div>

					{/* Typ Rozliczenia */}
					<div>
						<Label required>Typ odliczenia</Label>
						<Select
							style={{ width: "100%" }}
							disabled={isDisabled}
							value={
								reckoning.msr_reckonings_types_id ||
								wplyw?.wplyw_data?.data?.default_values
									?.msr_reckonings_types[0].value
							}
							defaultValue={
								wplyw?.wplyw_data?.data?.default_values
									?.msr_reckonings_types[0].value
							}
							options={
								wplyw?.wplyw_data?.data?.default_values
									?.msr_reckonings_types || []
							}
							onChange={(value) =>
								updateReckoningField(
									"msr_reckonings_types_id",
									value,
								)
							}
						/>
					</div>

					{/* Numer Dokumentu */}
					<div>
						<Label>Numer dokumentu</Label>
						<Input
							disabled={isDisabled}
							value={reckoning.msr_reckonings_document || ""}
							onChange={(e) =>
								updateReckoningField(
									"msr_reckonings_document",
									e.target.value,
								)
							}
						/>
					</div>
				</div>

				{/* Uwagi do odliczenia */}
				<div
					style={{
						display: open ? "grid" : "none",
						gridTemplateColumns: "1fr 400px",
						gap: "32px",
					}}
				>
					<div>
						<Label>Uwagi do odliczenia</Label>
						<CommentWithFragments
							commentName={"msr_reckonings_comment"}
							disabled={isDisabled}
							value={reckoning?.msr_reckonings_comment || ""}
							defaultValue={
								reckoning?.msr_reckonings_comment || ""
							}
							onChange={(e) =>
								updateReckoningField(
									"msr_reckonings_comment",
									e.target.value,
								)
							}
						/>
					</div>

					{/* Kwota Klienta po Rozliczeniu */}
					<div
						style={{
							borderRadius: "10px",
							background: "white",
							border: "1px solid black",
							padding: "10px",
							display: "flex",
							alignItems: "end",
							justifyContent: "end",
							textAlign: "right",
						}}
					>
						<div>
							<div style={labelStyle}>
								Kwota klienta po rozliczeniu
							</div>
							<div style={bigStyle}>
								{formatPrice(
									reckoning.msr_reckonings_part_amount -
										reckoning.msr_reckonings_deduction_from_income,
								)}{" "}
								zł
							</div>
						</div>
					</div>
				</div>
				{open && (
					<div
						style={{
							padding: "20px",
							background: "white",
							borderRadius: "5px",
						}}
					>
						<div
							style={{
								display: "flex",
								gap: "20px",
								alignItems: "center",
							}}
						>
							<div style={{ fontSize: "18px", flex: "none" }}>
								Odliczenie od kwoty{" "}
								<b style={{ fontWeight: "900" }}>
									{formatPrice(
										reckoning.msr_reckonings_part_amount -
											reckoning.msr_reckonings_deduction_from_income,
									)}{" "}
									zł
								</b>{" "}
								(kwota po rozliczeniu)
							</div>
							<LineSpacer />
							{!isDisabled && (
								<Button onClick={() => addDeduction()}>
									Dodaj odliczenie
								</Button>
							)}
						</div>
						{reckoning.msr_deductions.map((x, i) => (
							<ReckoningsDeduction
								selectedPerson={selectedPerson}
								index={i}
								deduction={x}
								preindex={index}
								reckoning={reckoning}
							></ReckoningsDeduction>
						))}
					</div>
				)}

				{/* Uwagi do odliczenia */}
				<div
					style={{
						borderRadius: "10px",
						background: "rgba(189, 129, 54, 0.11)",
						padding: "20px",
						display: open ? "grid" : "none",
						justifyContent: "end",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "end",
							flexDirection: "column",
						}}
					>
						<div style={labelStyle}>
							Kwota końcowa podziału #{index + 1}
						</div>
						<div style={bigStyle}>
							{formatPrice(
								parseFloat(
									reckoning.msr_reckonings_part_amount -
										reckoning.msr_reckonings_deduction_from_income -
										reckoning?.msr_deductions.reduce(
											(sum2, deductions) =>
												sum2 +
												parseFloat(
													deductions?.msr_deductions_amount ||
														0,
												),
											0,
										),
								),
							)}{" "}
							zł
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Reckonings;
